module.exports = __webpack_public_path__ + "img/pr-9.1e23d3ee.png";